export class ApiError extends Error { constructor(message: string, public status: number) { super(message); } }

const API_URL = import.meta.env.VITE_API_URL ?? '/api';

export const getAuthToken = () => localStorage.getItem('ehes_token');

export async function api<T>(path: string, options: RequestInit = {}): Promise<T> {
  const token = getAuthToken();
  const response = await fetch(`${API_URL}${path}`, {
    ...options,
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}), ...options.headers },
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new ApiError(payload.message ?? 'İşlem tamamlanamadı.', response.status);
  return payload as T;
}

export const currency = (value: number, code = 'TRY') => new Intl.NumberFormat('tr-TR', { style: 'currency', currency: code, maximumFractionDigits: 0 }).format(value);
export const dateTR = (value: string) => new Intl.DateTimeFormat('tr-TR', { day: '2-digit', month: 'short', year: 'numeric' }).format(new Date(value));
export const todayTR = () => {
  const parts = new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Istanbul', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
  const values = Object.fromEntries(parts.map(part => [part.type, part.value]));
  return `${values.year}-${values.month}-${values.day}`;
};
